module.exports = __webpack_public_path__ + "static/media/Cream & Pudding Cakes1.9709f3f4.jpg";